export default __webpack_public_path__ + "static/media/Purified Moonspill.793240b3.jpg";